import React, { useMemo } from 'react';
import NotesEditor from '../../../../shared/Notes/NotesEditor';
import { ResourcesTabParamList, useGoBack } from '../../../../../utils/appNavigationNames';
import { useEditNote } from '../../../../../hooks/api/useNotes';
import { RouteProp } from '@react-navigation/native';
import { View } from 'react-native';
import { useOrganizationId } from '../../../../../hooks/api/useOrganization';
import { OrganizationNoteDestination } from '../../../../shared/Notes/utils/types';

export type AddNoteOwnProps = {};

export type AddNoteProps = AddNoteOwnProps & {
    route: RouteProp<ResourcesTabParamList, 'add-note'>;
};

const AddNoteScreen: React.FC<AddNoteProps> = () => {
    const organizationId = useOrganizationId();
    const goBack = useGoBack();
    const noteDestination = useMemo<OrganizationNoteDestination>(
        () => ({
            entityType: 'organization',
            organizationId,
        }),
        [organizationId],
    );
    const { noteEditorProps, key } = useEditNote({
        noteDestination,
        onCreationSuccess: () => {
            goBack();
        },
    });
    return (
        <View style={{ width: '100%', height: '100%' }}>
            <NotesEditor
                key={key}
                source="resources.add-note-route"
                onCancel={() => goBack()}
                noteDestination={noteDestination}
                {...noteEditorProps}
            />
        </View>
    );
};

export default React.memo(AddNoteScreen);
